export const version = '2.31.7';
//# sourceMappingURL=version.js.map